/**
 * Checks if HTML string contains actual text content. Returns true if there is
 * any non-whitespace text, regardless of HTML structure. Returns false for
 * empty strings, whitespace-only content, or HTML with no text.
 */
export const hasTextContent = (html: string | null | undefined): boolean => {
  if (!html?.trim().length) return false;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const textOnly = doc.body.textContent ?? '';

  return textOnly.trim().length > 0;
};
